module.exports = __webpack_public_path__ + "img/Rooms_text03a_predAtrue.8630f039.png";